import NoInternetToSaveGameResult from '../components/ModalContent/noInternetToSaveGameResult';
import SaveGameResult from '../components/ModalContent/saveGameResult';
import GameResultSuccessfullySaved from '../components/ModalContent/gameResultSuccessfullySaved';
import ContinueActiveGame from '../components/ModalContent/continueActiveGame';
import FinishUncompletedGame from '../components/ModalContent/finishUncompletedGame';
import NoInternetToChangeLanguage from '../components/ModalContent/noInternetToChangeLanguage';
import TimeExpireNotification from '../components/ModalContent/timeExpireNotification';
import SomethingWentWrong from '../components/ModalContent/somethingWentWrong';
import SyncInProgress from '../components/ModalContent/syncInProgress';
import ConfirmDeleteRally from '../components/ModalContent/confirmDeleteRally';
import ConfirmDeleteTask from '../components/ModalContent/confirmDeleteTask';
import CannotPublishRally from '../components/ModalContent/cannotPublishRally';
import ConfirmDeleteTaskAnswer from '../components/ModalContent/confirmDeleteTaskAnswer';
import CannotDeleteTaskAnswer from '../components/ModalContent/cannotDeleteTaskAnswer';
import UnsavedSortingChanges from '../components/ModalContent/unsavedSortingChanges';
import DeactivateRally from '../components/ModalContent/deactivateRally';
import ShareSocials from '../components/ModalContent/shareSocials';
import RallyDoesNotExist from '../components/ModalContent/rallyDoesNotExist';
import ConfirmDeleteRallyStatistic from '../components/ModalContent/confirmDeleteRallyStatistic';
import CannotEditRally from '../components/ModalContent/cannotEditRally';
import CannotUploadFile from '../components/ModalContent/cannotUploadFile';
import DeactivateAdminUnit from '../components/ModalContent/deactivateAdminUnit';
import CannotFinishGame from '../components/ModalContent/cannotFinishGame';
import ConfirmDeleteAdminUnit from '../components/ModalContent/confirmDeleteAdminUnit';
import ConfirmDeleteFaqCategory from '../components/ModalContent/confirmDeleteFaqCategory';
import ConfirmDeleteFaqItem from '../components/ModalContent/confirmDeleteFaqItem';
import InstitutionVerificationData from '../components/ModalContent/institutionVerificationData';
import ConfirmCopyRally from '../components/ModalContent/confirmCopy';
import ConfirmEndGameSession from '../components/ModalContent/confirmEndGameSession';
import ReportProblem from '../components/ModalContent/reportProblem';
export const MODAL_CONTENT = {
    noInternetToSaveGameResult: {
        key: 'noInternetToSaveGameResult',
        component: NoInternetToSaveGameResult,
    },
    gameResultSuccessfullySaved: {
        key: 'gameResultSuccessfullySaved',
        component: GameResultSuccessfullySaved,
    },
    saveGameResult: {
        key: 'saveGameResult',
        component: SaveGameResult,
    },
    continueActiveGame: {
        key: 'continueActiveGame',
        component: ContinueActiveGame,
    },
    finishUncompletedGame: {
        key: 'finishUncompletedGame',
        component: FinishUncompletedGame,
    },
    noInternetToChangeLanguage: {
        key: 'noInternetToChangeLanguage',
        component: NoInternetToChangeLanguage,
    },
    timeExpireNotification: {
        key: 'timeExpireNotification',
        component: TimeExpireNotification,
    },
    somethingWentWrong: {
        key: 'somethingWentWrong',
        component: SomethingWentWrong,
    },
    syncInProgress: {
        key: 'syncInProgress',
        component: SyncInProgress,
    },
    confirmDeleteRally: {
        key: 'confirmDeleteRally',
        component: ConfirmDeleteRally,
    },
    confirmDeleteTask: {
        key: 'confirmDeleteTask',
        component: ConfirmDeleteTask,
    },
    cannotPublishRally: {
        key: 'cannotPublishRally',
        component: CannotPublishRally,
    },
    confirmDeleteTaskAnswer: {
        key: 'confirmDeleteTaskAnswer',
        component: ConfirmDeleteTaskAnswer,
    },
    cannotDeleteTaskAnswer: {
        key: 'cannotDeleteTaskAnswer',
        component: CannotDeleteTaskAnswer,
    },
    unsavedSortingChanges: {
        key: 'unsavedSortingChanges',
        component: UnsavedSortingChanges,
    },
    deactivateRally: {
        key: 'deactivateRally',
        component: DeactivateRally,
    },
    shareSocials: {
        key: 'shareSocials',
        component: ShareSocials,
    },
    rallyDoesNotExist: {
        key: 'rallyDoesNotExist',
        component: RallyDoesNotExist,
    },
    confirmDeleteRallyStatistic: {
        key: 'confirmDeleteRallyStatistic',
        component: ConfirmDeleteRallyStatistic,
    },
    cannotEditRally: {
        key: 'cannotEditRally',
        component: CannotEditRally,
    },
    cannotUploadFile: {
        key: 'cannotUploadFile',
        component: CannotUploadFile,
    },
    deactivateAdminUnit: {
        key: 'deactivateAdminUnit',
        component: DeactivateAdminUnit,
    },
    cannotFinishGame: {
        key: 'cannotFinishGame',
        component: CannotFinishGame,
    },
    confirmDeleteAdminUnit: {
        key: 'confirmDeleteAdminUnit',
        component: ConfirmDeleteAdminUnit,
    },
    confirmDeleteFaqCategory: {
        key: 'confirmDeleteFaqCategory',
        component: ConfirmDeleteFaqCategory,
    },
    confirmDeleteFaqItem: {
        key: 'confirmDeleteFaqItem',
        component: ConfirmDeleteFaqItem,
    },
    institutionVerificationData: {
        key: 'institutionVerificationData',
        component: InstitutionVerificationData,
    },
    confirmCopy: {
        key: 'confirmCopy',
        component: ConfirmCopyRally,
    },
    confirmEndGameSession: {
        key: 'confirmEndGameSession',
        component: ConfirmEndGameSession,
    },
    reportProblem: {
        key: 'reportProblem',
        component: ReportProblem,
    },
};
